import { useSelector } from 'react-redux';

import ComplianceDatesChecklist from 'components/complianceCalendar/ComplianceDatesChecklist';
import { usePageTitle } from 'utils/pageTitle';
// import './ComplianceDates.css';

const ComplianceDates = (props) => {
	const {
		propertyData,
		propertyId,
	} = useSelector(state => ({
		propertyData: state.property.propertyData,
		propertyId: state.property.propertyData?.id,
	}));
	usePageTitle('Compliance Dates', propertyData);
	return (
		<div className="property-overview">
			<div className="card">
				<div className="card-header">
					Compliance Dates
				</div>
				<div className="card-body">
					<ComplianceDatesChecklist showCalendarLink propertyId={propertyId} />
				</div>
			</div>
		</div>
	);	
}

export default ComplianceDates;
